<template>
  <div class="postAuditList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="village">
            <el-option key :label="$t('lang.villageall')" value v-if="showGarden"></el-option>
            <el-option
              v-for="(item,index) in villagetypes"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="postclassificationvalue ">
            <el-option key :label="$t('lang.postclassification')" value></el-option>
            <el-option
              v-for="(item,index) in labelData"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="auditstatusvalue" :placeholder="$t('lang.lab_please_Select')">
            <el-option key :label="$t('lang.auditstatus')" value></el-option>
            <el-option
              v-for="(item,index) in auditstatus"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
            <el-select v-model="isTs" placeholder="是否投诉">
              <el-option label="是否投诉" value></el-option>
              <el-option label="是" value = 1></el-option>
              <el-option label="否" value = 2></el-option>
            </el-select>
          </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-table
        :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column :label="$t('lang.lab_poster')">
          <template slot-scope="scope">
            <span v-if="scope.row.user!=null">{{ scope.row.user.userName |valueIsNull }}</span>
            <span v-else>---</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" sortable :label="$t('lang.lab_postingtime')">
          <template slot-scope="scope">{{ scope.row.createTime | time }}</template>
        </el-table-column>
        <el-table-column prop="gardenName" sortable :label="$t('lang.lab_village')"></el-table-column>
        <el-table-column prop="type" :label="$t('lang.postclassification')">
          <template slot-scope="scope">{{ scope.row.result }}</template>
        </el-table-column>
        <el-table-column prop="state" sortable :label="$t('lang.auditstatus')">
          <template slot-scope="scope">
            <span
              v-if="scope.row.state === 1"
              class="red"
            >{{$t('lang.POSTAUDIT.STATUEDETAIL[0].label')}}</span>
            <span v-if="scope.row.state === 2">{{$t('lang.POSTAUDIT.STATUEDETAIL[1].label')}}</span>
            <span v-if="scope.row.state === 3">{{$t('lang.POSTAUDIT.STATUEDETAIL[2].label')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="投诉理由">
          <template slot-scope="scope">{{ scope.row.reason }}</template>
        </el-table-column>
        <el-table-column
          prop="operation"
          :label="$t('lang.lab_operation')"
          fixed="right"
          :width="require('@/config/enum').opr_width2"
        >
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id,scope.row.state)">{{$t('lang.btn_modify')}}</el-button>
            <el-button
              class="orange"
              @click="deletetable(scope.row.id)"
            >{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>

    <el-dialog
      :visible.sync="show"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      :title="title"
      @closed="handleDialogClosed"
    >
      
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item :label="$t('lang.lab_postingusername')">
            <span v-if="this.form.user!= null">{{ this.form.user.userName | valueIsNull }}</span>
            <span v-else>---</span>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_postingtimes')">{{this.form.createTs | time}}</el-form-item>
          <el-form-item :label="$t('lang.lab_postingdetail')">
            {{this.form.content}}
          </el-form-item>
          <el-form-item v-if="this.form.files && this.form.files.length >0">
            <viewer :images="this.form.files">
              <img
                  v-for="(src,index) in this.form.files"
                  :src="src.uri"
                  :key="index"
                  class="filesimg"/>
            </viewer>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_postingtelephone')">
            <span v-if="this.form.user!= null">{{ this.form.user.mobile |valueIsNull }}</span>
            <span v-else>---</span>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_postingtype')">{{ this.form.result }}</el-form-item>
          <el-form-item :label="$t('lang.lab_posting')">
            <el-select v-model="form.state">
              <el-option
                v-for="item in auditstatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      <div slot="footer">
        <el-button @click="handleDialogClosed()">{{$t('lang.btn_backpage')}}</el-button>
        <el-button type="primary" :disabled="isDisabled" @click="onSubmit">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 *@ClassName:postAuditList
 *@Description:发帖审核
 *@author:孙斯维
 *@Copyright:格众科技
 *@date:2020-02-19
 */
export default {
  name:'/manage/main.topics',
  data() {
    return {
      showGarden: true,
      labelData: [],
      title: this.$i18n.t('lang.modifyposting'), // 切换修改新增title
      id: '', // 区分新增和修改
      saveData: '', // 存储json字符串
      isDisabled: true, // 确定按钮置灰
      form: {}, // 通过id查询对象
      value: '1', // 弹框下拉绑定值
      show: false, // 弹框开关
      multipleSelection: [], // 多选框
      villagetypes: [], // 小区列表
      key: '', // 关键字搜索
      village: '', // 绑定小区code值
      postclassificationvalue: '', // 帖子分类code值
      auditstatusvalue: '', // 审核状态code值
      isTs: '',
      pageCount: 0, // 总页数
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      tableData: [], // 查询list
      auditstatus: this.$i18n.t('lang.POSTAUDIT.STATUEDETAIL'), // 审核状态list
      postclassification: this.$i18n.t('lang.POSTAUDIT.TYPE'), // 帖子分类list
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox // 是否隐藏复选框
    }
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.$store.getters.permission === '*') {
      this.village = ''
      this.showGarden = true
      this.gardens()
    } else {
      this.showGarden = false
      this.village = this.$store.getters.gardenId
      this.villagetypes = this.$store.getters.userGardenList
    }

    this.topics()
    this.list()
  },
  methods: {
    // 帖子分类
    list() {
      let loading = this.$loading()
      this.$get(`/tab?pageSize=999&pageNo=1`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.labelData = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.show = false
    },
    onSubmit() {
      let params = {
        state: Number(this.form.state)
      }
      let loading = this.$loading()
      this.$patch(`/topics/${this.id}`, params).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.$message.success(this.$i18n.t('lang.lab_modify_success'))
            this.commit()
            this.show = false
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // CHECKBOX
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 小区下拉
    gardens() {
      let loading = this.$loading()
      this.$get(`/gardens`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.villagetypes = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 查询
    topics() {
      let loading = this.$loading()
      this.$get(
        `/gardens/${this.$store.getters.gardenId}/topics?gardenId=${
          this.village
        }&pageSize=${this.pageSize}&pageNo=${
          this.pageNum
        }&key=${this.key.trim()}&type=${this.postclassificationvalue}&state=${
          this.auditstatusvalue
        }&isTs=${this.isTs}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            for (let i = 0; i < this.tableData.length; i++) {
              for (let j = 0; j < this.labelData.length; j++) {
                if (this.tableData[i].type === this.labelData[j].id) {
                  this.tableData[i].result = this.labelData[j].name
                }
              }
            }
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 查询按钮
    commit() {
      this.pageNum = 1
      this.topics()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.topics()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.topics()
    },
    // 修改按钮
    edit(id) {
      this.id = id
      let loading = this.$loading()
      this.$get(`/topics/` + id).then(
        res => {
          loading.close()
          if (res) {
            this.form = res
            if (this.form.user) {
              this.form.mobile = this.form.user.mobile
              this.form.userName = this.form.user.userName
            }
            this.form.state = this.form.state.toString()
            this.show = true
            for (let j = 0; j < this.labelData.length; j++) {
              if (this.form.type === this.labelData[j].id) {
                this.form.result = this.labelData[j].name
              }
            }
            this.saveData = JSON.stringify(this.form)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    //  删除按钮
    deletetable(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          this.$delete(`/topics/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    }
  }
}
</script>

<style lang="scss">
.el-tooltip__popper.is-light {
  max-width: 300px;
}
.filesimg {
  width: 100px;
  padding: 5px;
  height: 150px;
}
</style>